module.exports = __webpack_public_path__ + "static/sportovni-den-2022-05-8efbfcd41442c2b2c6b2340bb2942c60.jpg";